export const EXECUTION_LIVE_MAX_RECONNECT_ATTEMPTS = 8;

export const executionLiveReconnectDelayMs = (attempt: number): number => {
  const safeAttempt = Number.isInteger(attempt) && attempt > 0 ? attempt : 0;
  return Math.min(15_000, 500 * 2 ** Math.min(safeAttempt, 5));
};

export const canRetryExecutionLive = (attempt: number): boolean =>
  attempt < EXECUTION_LIVE_MAX_RECONNECT_ATTEMPTS;

// Once the fast reconnect budget above is spent (~90s of backoff), the live
// stream is treated as disconnected rather than failed. We then fall back to
// a slow REST poll so a deposit/withdrawal that settles while the socket is
// down still resolves on its own — the network being down is not the
// operation failing.
export const EXECUTION_LIVE_DISCONNECTED_RECOVERY_POLL_MS = 15_000;
